import { DownOutlined } from '@ant-design/icons';
import { env, setEnv } from '@micun/web-components';
import { Button, Dropdown } from 'antd';
import { useUpdate } from 'react-use';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Env() {
  var isProd = process.env.REACT_APP_ENV === 'production';
  var update = useUpdate();
  if (isProd) {
    return null;
  }
  var items = [{
    label: 'dev',
    key: 'dev'
  }, {
    label: 'dev2',
    key: 'dev2'
  }, {
    label: 'beta',
    key: 'beta'
  }, {
    label: 'beta2',
    key: 'beta2'
  }, {
    label: 'prod',
    key: 'prod'
  }];
  var onSwitchEnv = function onSwitchEnv(menu) {
    setEnv(menu.key);
    update();
  };
  return /*#__PURE__*/_jsx(Dropdown, {
    menu: {
      items: items,
      onClick: onSwitchEnv
    },
    children: /*#__PURE__*/_jsxs(Button, {
      children: [env, /*#__PURE__*/_jsx(DownOutlined, {})]
    })
  });
}
export default Env;